import React ,{useContext}from 'react'
import Meta from '../components/Meta'
import BreadCrumb from '../components/BreadCrumb'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft} from '@fortawesome/free-solid-svg-icons'
import { useParams } from 'react-router-dom';
import ProductProvider, { ProductContent } from '../components/Context/ProductProvider';


import {Link} from 'react-router-dom'

const Blog = () => {
    const { id } = useParams();
  const { GetBlogs, DeleteBlog } = useContext(ProductContent)
    
    const display = GetBlogs?.data?.filter(item => item._id === id);
    return (
        <>
            <Meta title={"Dynamic Blog Name"} />
            <BreadCrumb title='Dynamic Blog Name' />
            <div className="blog-wrapper home-wrapper-2 py-5">
                <div className="container-xxl">
                    <div className="row">
                        <div className="col-12">
                        {display?.map((item, index) => (
                            <div className="single-blog-card">
                                   <Link to='/blogs' className='d-flex align-items-center gap-10'><FontAwesomeIcon icon={faArrowLeft} className='f-4'/>Go back to Blogs</Link>
                                    <h3 className='title'>A beautiful Sunday Morning Renaissance</h3>
                                    <img src={item?.image} className='img-fluid w-100 my-4' alt="blog" />
                                    <p><span className='single_blog_p'>Title:</span> <span>{item.title}</span></p>
              <p><span className='single_blog_p'>Views:</span>Views: <span>{item.numViews}</span></p>
              <p className='single_blog_p'>Description:</p>
              <p><span>{item.description}</span></p>
                            </div>
                             ))}
                        </div>
                        
                    </div>
                </div>
            </div>
        </>
    )
}

export default Blog